<template>
  <!-- eslint-disable max-len -->
  <div class="section center">
    <template v-if="passDownloaded">
      <span class="spacing inline-block">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          fill="var(--color-success)"
          width="3rem"
          height="3rem"
        >
          <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z" />
        </svg>
      </span>
      <p class="title title--4">Your Apple Wallet pass has been successfully downloaded!</p>
    </template>
    <template v-else>
      <h1 class="title title--2">Apple Wallet Pass Downloading</h1>
      <p>Your pass should begin downloading shortly. If not, try clicking the button below.</p>
      <a
        class="cursor-pointer spacing inline-block"
        target="_system"
        @click="handleAddToAppleWallet"
      >
        <img
          style="height: var(--input-height)"
          src="/images/apple-wallet.svg"
        >
      </a>
    </template>
  </div>
</template>

<script>
  import events from '@/services/events';
  import logger from '@/services/logger';
  import { downloadOrderRedemptionAppleWalletPass } from '@/services/api/order-redemption';



  export default {
    name: 'AppleWalletPass',

    data() {
      return {
        passDownloaded: false
      };
    },

    mounted() {
      this.handleMounted();
    },

    methods: {
      handleMounted() {
        setTimeout(() => {
          this.handleAddToAppleWallet();
        }, 1500);
      },

      async handleAddToAppleWallet() {
        try {
          await downloadOrderRedemptionAppleWalletPass(this.$route.query);
          this.passDownloaded = true;
        }

        catch (error) {
          logger.error(error);
          events.emit('notification', {
            clickToDismiss: false,
            duration: 3500,
            message: 'There was an issue generating your pass',
            type: 'error'
          });
        }
      }
    }
  };
</script>
